export default "/_next/static/images/26d9c1494c34e0fef368b811342346e9.jpg";